import { useDraftProvider } from '../../../Draft'
import { ApplicantDraft } from '../RentalPortalApplicants.context'

function RentalPortalApplicantDraftProvider({
  DraftContext = ApplicantDraft,
  children,
  prefix,
}) {
  const value = useDraftProvider({ draftId: prefix })

  return <DraftContext value={value}>{children}</DraftContext>
}

export default RentalPortalApplicantDraftProvider
